module.exports = __webpack_public_path__ + "img/txp1.6f5f5f28.jpg";